<app-megamenu></app-megamenu>

<div class="page-content">
  <div class="container">
    <h1>Contact {{ config.name }}</h1>
    <p>Get in touch with us for all your pest control needs. We're here to help!</p>
    
    <div class="contact-grid">
      <div class="contact-info">
        <h2>Get In Touch</h2>
        
        <div class="contact-item">
          <mat-icon>phone</mat-icon>
          <div>
            <h3>Phone</h3>
            <p>{{ config.phone.display }}</p>
          </div>
        </div>

        <div class="contact-item">
          <mat-icon>email</mat-icon>
          <div>
            <h3>Email</h3>
            <p>{{ config.email }}</p>
          </div>
        </div>

        <div class="contact-item">
          <mat-icon>schedule</mat-icon>
          <div>
            <h3>Hours</h3>
            <p>Monday - Friday: {{ config.hours.weekdays }}<br>
               Saturday: {{ config.hours.saturday }}<br>
               Sunday: {{ config.hours.sunday }}</p>
          </div>
        </div>
      </div>

      <div class="lead-form-section">
        @if (!formSubmitted) {
          <h2>Get Your Free Quote</h2>
          <p>Fill out the form below and we'll contact you with a free, no-obligation quote.</p>
          
          <form [formGroup]="leadForm" (ngSubmit)="onSubmitLead()" class="lead-form">
            <mat-form-field appearance="outline">
              <mat-label>Full Name</mat-label>
              <input matInput formControlName="name" placeholder="Enter your full name">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error>
                @if (leadForm.get('name')?.touched && leadForm.get('name')?.errors) {
                  {{ getErrorMessage('name') }}
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>ZIP Code</mat-label>
              <input matInput formControlName="zipCode" placeholder="Enter your ZIP code">
              <mat-icon matSuffix>location_on</mat-icon>
              <mat-error>
                @if (leadForm.get('zipCode')?.touched && leadForm.get('zipCode')?.errors) {
                  {{ getErrorMessage('zipCode') }}
                }
              </mat-error>
            </mat-form-field>

            <div class="contact-method-section">
              <mat-form-field appearance="outline">
                <mat-label>Preferred Contact Method</mat-label>
                <mat-select formControlName="contactPreference">
                  <mat-option value="TEXT">Text</mat-option>
                  <mat-option value="EMAIL">Email</mat-option>
                </mat-select>
              </mat-form-field>

              @if (leadForm.get('contactPreference')?.value === 'TEXT') {
                <mat-form-field appearance="outline">
                  <mat-label>Phone Number</mat-label>
                  <input matInput 
                         formControlName="phone" 
                         placeholder="(555) 123-4567" 
                         type="tel"
                         maxlength="14"
                         (input)="formatPhoneNumber($event)"
                         (keydown)="onPhoneKeyDown($event)">
                  <mat-icon matSuffix>phone</mat-icon>
                  <mat-error>
                    @if (leadForm.get('phone')?.touched && leadForm.get('phone')?.errors) {
                      {{ getErrorMessage('phone') }}
                    }
                  </mat-error>
                </mat-form-field>
              }

              @if (leadForm.get('contactPreference')?.value === 'EMAIL') {
                <mat-form-field appearance="outline">
                  <mat-label>Email Address</mat-label>
                  <input matInput formControlName="email" placeholder="Enter your email address" type="email">
                  <mat-icon matSuffix>email</mat-icon>
                  <mat-error>
                    @if (leadForm.get('email')?.touched && leadForm.get('email')?.errors) {
                      {{ getErrorMessage('email') }}
                    }
                  </mat-error>
                </mat-form-field>
              }
            </div>

            @if (leadForm.hasError('contactMethodRequired') && leadForm.touched) {
              <div class="form-error">
                {{ getErrorMessage('contact') }}
              </div>
            }

            <div class="form-actions">
              <button mat-raised-button type="submit" class="submit-btn" [disabled]="isSubmitting">
                @if (isSubmitting) {
                  <mat-spinner diameter="20"></mat-spinner>
                } @else {
                  <mat-icon>send</mat-icon>
                }
                {{ isSubmitting ? 'Submitting...' : 'Get Free Quote' }}
              </button>
              
              <div class="or-divider">
                <span>or</span>
              </div>
              
              <button mat-stroked-button type="button" class="call-btn" (click)="callPhone()">
                <mat-icon>phone</mat-icon>
                Call {{ config.phone.display }}
              </button>
            </div>
          </form>
        } @else {
          <div class="success-message">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <h2>Thank You!</h2>
            <p>We've received your request and will contact you soon with your free, no-obligation quote.</p>
            <p>If you need immediate assistance, please call us at {{ config.phone.display }}.</p>
            <button mat-stroked-button class="call-btn" (click)="callPhone()">
              <mat-icon>phone</mat-icon>
              Call Now
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>